export default el => {
	var script = document.querySelector('#script-yt');
	
	if (!script) {
		// youtube
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		tag.id = "script-yt";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	const evt = new CustomEvent('yt_ready', {});
	document.addEventListener('yt_ready', () => {
		init();
	}, { once: true });

	if (window.YT) {
		document.dispatchEvent(evt);
	} else {
		window.onYouTubePlayerAPIReady = function() {
			document.dispatchEvent(evt);
		}
	}

	const init = () => {
		const id = el.dataset.videoYoutubeId;
		const iframe = el.querySelector('.js-iframe');

		const yt_player = new YT.Player(iframe, {
			height: '100%',
			width: '100%',
			videoId: id,
			playerVars: {
				'modestbranding': 1,
				'controls': 1,
				'rel': 0,
				'showinfo': 0
			},

			events: {
				onStateChange: (e) => {
					if (el.classList.contains('card-embed')) {
						if (e.data == YT.PlayerState.ENDED || e.data == YT.PlayerState.PAUSED) {
							el.classList.remove('playing');
						} else if (e.data == YT.PlayerState.PLAYING) {
							el.classList.add('playing');
						}
					}
				}
			}
		});

		el.addEventListener('click', (e) => {
			if (yt_player.getPlayerState() == YT.PlayerState.PLAYING) {
				yt_player.pauseVideo();
				el.classList.remove('playing');
				return;
			}

			yt_player.playVideo();
			el.classList.add('playing');
		});
	}
};